<template>
  <div class="illu-teaser">
    <div class="wrapper">
      <div class="row between-xs">
        <div class="text col-xs-12 col-md-7">
          <Headline :subline="subline" :headline="headline" />
          <slot class="description" />
        </div>
        <div class="illu col-xs-12" :class="{ 'col-md-4' : columns=='4', 'col-md-5' : columns=='5' }">
          <img :src="illustrations[illu]" alt="Illustration">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Headline from '../Headline/Headline';

import savings from '../../assets/images/illustrations/savings.svg';
import dataInput from '../../assets/images/illustrations/data-input.svg';
import messages from '../../assets/images/illustrations/messages.svg';
import postbox from '../../assets/images/illustrations/postbox.svg';
import security from '../../assets/images/illustrations/security.svg';
import settings from '../../assets/images/illustrations/settings.svg';

const illustrations = {
  savings,
  dataInput,
  messages,
  postbox,
  security,
  settings
}

export default {
  name: 'Teaser',
  components: {
    Headline,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    subline: {
      type: String,
      required: true,
    },
    illu: {
      type: String,
      required: true,
    },
    columns: {
      type: String,
      default: '4',
    },
  },
  computed: {
    illustrations() {
      return illustrations
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Teaser.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Teaser/Teaser.vue